import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_yixz",
  "use": "icon-icon_yixz-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-icon_yixz\">\n<style type=\"text/css\">\n\t#icon-icon_yixz .st0{fill:#040000;}\n\t#icon-icon_yixz .st1{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<path d=\"M512,114c-219.65,0-398,178.35-398,398s178.93,398,398,398c219.07,0,398-178.35,398-398S731.65,114,512,114z M649.64,456.37\n\tL494.8,611.21c-5.73,5.73-13.48,8.6-21.22,8.6c-2.9,0-5.81-0.4-8.6-1.21c-0.93-0.27-1.85-0.58-2.76-0.94\n\tc-1.36-0.54-2.68-1.18-3.95-1.92c-0.42-0.25-0.84-0.5-1.26-0.77c-0.83-0.54-1.63-1.12-2.41-1.75c-0.78-0.63-1.52-1.3-2.24-2.02\n\tl-78.57-78.57c-11.47-11.47-11.47-30.97,0-42.44c11.47-11.47,30.97-11.47,42.44,0l57.35,57.35L607.2,413.93\n\tc11.47-11.47,30.97-11.47,42.44,0C661.11,425.4,661.11,444.9,649.64,456.37z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon_yixz.svg
// module id = 3AkF
// module chunks = 103